import { render, staticRenderFns } from "./DormUpdate.vue?vue&type=template&id=5d475ea0&"
import script from "./DormUpdate.vue?vue&type=script&lang=js&"
export * from "./DormUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports